export default __webpack_public_path__ + "static/media/1_16.47191212.png";